import { toast } from "sonner";

/**
 * Exports purchase invoices (array of objects with header + lines)
 * into an itemized CSV format compatible with Excel and Google Sheets.
 */
export function exportPurchaseInvoicesToCsv(invoices, filename = "Purchase_Invoices.csv", titleContext = "") {
  if (!invoices || !invoices.length) {
    toast.error("No purchase invoices to export");
    return;
  }

  const headers = [
    "Invoice Date",
    "Invoice Number",
    "Vendor",
    "Product / Master SKU",
    "Quantity",
    "Unit Cost (Ex-GST)",
    "Base Amount (Ex-GST)",
    "GST %",
    "GST Amount",
    "Line Total (Inc-GST)",
    "Invoice Grand Total",
    "Invoice Total GST",
    "Invoice Subtotal (Ex-GST)",
    "Created By",
    "Notes",
  ];

  const rows = [];
  rows.push(["Geetanjali Salon — Purchase Invoices Report" + (titleContext ? ` (${titleContext})` : "")]);
  rows.push(["Exported At", new Date().toLocaleString()]);
  rows.push(["Total Invoices Included", invoices.length]);
  rows.push([]);
  rows.push(headers);

  let grandQty = 0;
  let grandBase = 0;
  let grandGst = 0;
  let grandTotal = 0;

  invoices.forEach((inv) => {
    const invDate = (inv.invoice_date || "").slice(0, 10);
    const lines = inv.lines || [];
    const invGst = Number(inv.gst_total || 0);
    const invTot = Number(inv.total || 0);
    const invSub = Number(inv.subtotal ?? (invTot - invGst));

    if (lines.length === 0) {
      rows.push([
        invDate,
        inv.invoice_number || "",
        inv.vendor || "",
        "— No Line Items Recorded —",
        "0",
        "0.00",
        "0.00",
        "0%",
        invGst.toFixed(2),
        invTot.toFixed(2),
        invTot.toFixed(2),
        invGst.toFixed(2),
        invSub.toFixed(2),
        inv.created_by || "",
        inv.notes || "",
      ]);
    } else {
      lines.forEach((l) => {
        const qty = Number(l.quantity || 0);
        const unitCost = Number(l.unit_cost || 0);
        const baseAmt = qty * unitCost;
        const gstPct = Number(l.gst_pct || 0);
        const gstAmt = Number(l.gst_amount || 0);
        const lineTot = Number(l.line_total || baseAmt + gstAmt);

        grandQty += qty;
        grandBase += baseAmt;
        grandGst += gstAmt;
        grandTotal += lineTot;

        rows.push([
          invDate,
          inv.invoice_number || "",
          inv.vendor || "",
          l.sku_name || l.product_name || "—",
          qty,
          unitCost.toFixed(2),
          baseAmt.toFixed(2),
          gstPct ? `${gstPct}%` : "0%",
          gstAmt.toFixed(2),
          lineTot.toFixed(2),
          invTot.toFixed(2),
          invGst.toFixed(2),
          invSub.toFixed(2),
          inv.created_by || "",
          inv.notes || "",
        ]);
      });
    }
  });

  // Grand totals row
  rows.push([]);
  rows.push([
    "TOTALS",
    "",
    "",
    `${invoices.length} invoices`,
    grandQty,
    "",
    grandBase.toFixed(2),
    "",
    grandGst.toFixed(2),
    grandTotal.toFixed(2),
    "",
    "",
    "",
    "",
    "",
  ]);

  const csv = rows
    .map((r) =>
      r
        .map((cell) => `"${String(cell === undefined || cell === null ? "" : cell).replace(/"/g, '""')}"`)
        .join(",")
    )
    .join("\r\n");

  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  toast.success(`Exported ${invoices.length} purchase invoices to CSV`);
}
